import React from 'react';
import { Search, Filter, Download, User, Calendar, Mail, Phone } from 'lucide-react';

const SERVICE_LABELS = {
  'wealth-rebuild': 'Wealth Rebuild System™',
  'credit-optimization': 'Credit Optimization',
  'business-formation': 'Business Formation',
  'tradelines': 'Primary Tradelines',
  'student-loans': 'Student Loan Removal',
  'funding-readiness': '90-Day Funding Readiness',
  'consultation': 'General Consultation',
  'elite-transformation': 'Elite Business Transformation',
};

const ApplicationsPanel = ({
  applications,
  filtered,
  searchTerm,
  setSearchTerm,
  filterService,
  setFilterService,
  sortBy,
  setSortBy,
  onExport,
  formatDate,
}) => {
  return (
    <>
      <section className="admin-controls">
        <div className="admin-controls-content">
          <div className="admin-search">
            <Search size={20} />
            <input
              type="text"
              placeholder="Search by name, email, or phone..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="admin-search-input"
              data-testid="admin-search-input"
            />
          </div>

          <div className="admin-filters">
            <div className="admin-filter-group">
              <Filter size={20} />
              <select
                value={filterService}
                onChange={(e) => setFilterService(e.target.value)}
                className="admin-select"
                data-testid="filter-service-select"
              >
                <option value="all">All Services</option>
                <option value="wealth-rebuild">Wealth Rebuild System™</option>
                <option value="elite-transformation">Elite Business Transformation</option>
                <option value="credit-optimization">Credit Optimization</option>
                <option value="business-formation">Business Formation</option>
                <option value="tradelines">Primary Tradelines</option>
                <option value="student-loans">Student Loan Removal</option>
                <option value="funding-readiness">90-Day Funding Readiness</option>
                <option value="consultation">General Consultation</option>
              </select>
            </div>

            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="admin-select"
              data-testid="sort-select"
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
              <option value="name">Name (A-Z)</option>
            </select>
          </div>

          <button onClick={onExport} className="btn-primary admin-export" data-testid="export-csv-btn">
            <Download size={20} />
            Export CSV
          </button>
        </div>
      </section>

      <section className="admin-applications">
        {filtered.length === 0 ? (
          <div className="admin-empty">
            <p className="body-large">No applications found matching your criteria.</p>
          </div>
        ) : (
          <div className="admin-grid">
            {filtered.map((app) => (
              <div key={app.id} className="admin-card" data-testid="application-card">
                <div className="admin-card-header">
                  <div className="admin-card-name">
                    <User size={20} />
                    <span>{app.firstName} {app.lastName}</span>
                  </div>
                  <div className="admin-card-date">
                    <Calendar size={16} />
                    <span>{formatDate(app.timestamp)}</span>
                  </div>
                </div>

                <div className="admin-service-badge">
                  {SERVICE_LABELS[app.serviceInterest] || app.serviceInterest}
                </div>

                <div className="admin-card-contacts">
                  <div className="admin-contact-item">
                    <Mail size={16} />
                    <a href={`mailto:${app.email}`}>{app.email}</a>
                  </div>
                  <div className="admin-contact-item">
                    <Phone size={16} />
                    <a href={`tel:${app.phone}`}>{app.phone}</a>
                  </div>
                </div>

                <div className="admin-card-details">
                  {app.currentCreditScore && (
                    <div className="admin-detail-item">
                      <span className="detail-label">Credit Score:</span>
                      <span className="detail-value">{app.currentCreditScore}</span>
                    </div>
                  )}
                  {app.businessStatus && (
                    <div className="admin-detail-item">
                      <span className="detail-label">Business:</span>
                      <span className="detail-value">{app.businessStatus}</span>
                    </div>
                  )}
                  {app.fundingGoal && (
                    <div className="admin-detail-item">
                      <span className="detail-label">Funding Goal:</span>
                      <span className="detail-value">{app.fundingGoal}</span>
                    </div>
                  )}
                </div>

                {app.message && (
                  <div className="admin-card-message">
                    <p className="message-label">Message:</p>
                    <p className="message-text">{app.message}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
};

export default ApplicationsPanel;
